import mixpanel, { type Callback, type Dict, type RequestOptions } from 'mixpanel-browser';

import { getAppContext } from '@/helpers/get-app-context';

const appContext = getAppContext();
const user = window.__DATA__?.user;

let mixpanelInitialized = false;

export function initialize() {
  mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN, {
    batch_requests: false,
    debug: false,
    persistence: 'localStorage',
    track_pageview: false,
  });

  if (user) {
    mixpanel.identify(String(user.member_id));
    mixpanel.people.set(appContext.MIXPANEL_PROPERTIES);
    mixpanel.register(appContext.MIXPANEL_PROPERTIES);
  }

  mixpanelInitialized = true;
}

export function startSessionRecording() {
  if (mixpanelInitialized) {
    mixpanel.set_config({
      record_sessions_percent: 50,
      record_mask_text_selector: "input[type=password]",
    });
    mixpanel.start_session_recording();
  }
}

export function stopSessionRecording() {
  if (mixpanelInitialized) {
    mixpanel.stop_session_recording();
  }
}

export function track(
  eventName: string,
  properties?: Dict,
  optionsOrCallback?: RequestOptions | Callback,
  callback?: Callback,
) {
  if (!mixpanelInitialized) {
    return;
  }

  mixpanel.track(eventName, properties, optionsOrCallback, callback);
}

export function appendUserProperties(appendProperties: Dict) {
  if (!mixpanelInitialized) {
    return;
  }

  if (appendProperties && Object.keys(appendProperties).length > 0) {
    mixpanel.people.append(appendProperties);
  }
}

export function updateSuperProperties(properties: Dict) {
  if (!mixpanelInitialized) {
    return;
  }

  if (properties && Object.keys(properties).length > 0) {
    mixpanel.register(properties);
  }
}